/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"free-course-license-page": require("./free-course-license-page.json"),
};
